import { Button } from '@/components/ui/button';
import { useCart } from '@/hooks/use-cart';
import { useDictionary } from '@/lib/context/locale-provider';
import CheckBoxOff from '@/public/images/ic_cbox_off.svg';
import CheckBoxOn from '@/public/images/ic_cbox_on.svg';
import Image from 'next/image';
import React from 'react';

function CartSelectAll({ serials }: { serials: string[] }) {
  const dict = useDictionary();
  const { state, dispatch } = useCart();

  const handleSelectAll = () => {
    if (state.selectedItems.length === serials.length) {
      dispatch({ type: 'CLEAR_ALL' });
    } else {
      dispatch({
        type: 'SELECT_ALL',
        payload: serials,
      });
    }
  };

  return (
    <Button variant="ghost" className="p-0" onClick={handleSelectAll}>
      <Image
        src={
          serials.length > 0 && state.selectedItems.length === serials.length
            ? CheckBoxOn
            : CheckBoxOff
        }
        alt="Select All"
        width={25}
        height={25}
      />
      <span className="text-lg font-medium giftifan5">
        {dict!.active.selectAll}
      </span>
    </Button>
  );
}

export default CartSelectAll;
